module.exports = __webpack_public_path__ + "static/media/firebase.0887b85f.svg";